import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ProjectPipelineInfo } from 'src/app/model/projectpipeline.model';
import { LookupInfo } from 'src/app/model/lookup.model';
import { StateMappingInfo } from 'src/app/model/StateMappingInfo.model';
import { ProjectSaleQuotationInfo } from 'src/app/model/ProjectSaleQuotationInfo.model';
import { ProjectSaleQuotationAttachmentInfo } from 'src/app/model/ProjectSaleQuotationAttachmentInfo.model';
import { TokenService } from 'src/app/service/token.service';
import { HttpClient, HttpHeaders,HttpEventType } from '@angular/common/http';
import { GlobalService } from 'src/app/service/global.service';
import { ChangeDetectorRef } from '@angular/core';
import {
  environment
} from 'src/environments/environment';
import { ProjectSaleInfo } from 'src/app/model/projectsale.model';
import { QuotationInfo } from 'src/app/model/QuotationInfo.model';
import { QuotationProductInfo } from 'src/app/model/QuotationProductInfo.model';

@Component({
  selector: 'app-update-pipeline-dialog',
  templateUrl: './update-pipeline-dialog.component.html',
  styleUrls: ['./update-pipeline-dialog.component.css']
})
export class UpdatePipelineDialogComponent implements OnInit {
  isViewMode: boolean = false;
  isElevated: boolean = false;
  projectData = new ProjectPipelineInfo();
  form: FormGroup;
  formProjectSaleQuotation: FormGroup;
  baseurl: string;

  // Lists for dropdowns
  ListSubState: StateMappingInfo[] = [];
  ListPipeline: LookupInfo[] = [];
  monthNameslist: any[] = [];
  yearlist: any[] = [];
  PriorityList: LookupInfo[] = [];

  ProjectSaleQuotaionList: ProjectSaleQuotationInfo[] = [];
  isOnUpdateProjectSaleQuotation: boolean;
  isSubmitted: any;
  hidProjectSaleQuotaionID: number
  _RoleCode: string;
  detailmodal: string;

  formMonth = "";
  formYear = "";
  isLoading: boolean = false;
  _EmpCode: string

  // Quotation Improve management selected
  duplicateQuotationError: boolean = false;
  QuotationList: QuotationInfo[] = [];
  QuotationProductList: QuotationProductInfo[] = [];
  ProjectSaleQuotationAttachedmentList: ProjectSaleQuotationAttachmentInfo[] = [];

  projectsaleQuotationFilesToUpload: File[];
  projectsaleQuotationPathFile: string = '';

  isProjectSaleQuotationAttachedmentSubmitted: any;
  IsClearProjectSaleQuotationAttachedmentList: string = '';
  isShowTabAssignMember: boolean = true;
  IsQuotationAttach: boolean = false;

  modalDocName: string;
  modalDocInfo: any;
  titlemodal: string
  NewCompanyCode: string = '';

  constructor(
    public dialogRef: MatDialogRef<UpdatePipelineDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private GlobalService: GlobalService,
    private TokenService: TokenService,
    private httpClient: HttpClient,
    private cdr: ChangeDetectorRef
  ) {
    this.baseurl = environment.base_api;

    // Initialize an empty form
    this.form = this.fb.group({
      ProjectPipelineId: [''],
      ProjectPipelineProjectSaleId: [''],
      ProjectPipelineSubStateCode: ['', Validators.required],
      ProjectPipelineSubStateName: [''],
      ProjectPipelineStatusLookupCode: ['', Validators.required],
      ProjectPipelineStatusLookupValue: [''],
      ProjectPipelineCreateDate: [''],
      ProjectSaleClosedPeriodMonth: ['', Validators.required],
      ProjectSaleClosedPeriodYear: ['', Validators.required],
      ProjectPipelineComission: [''],
      ProjectPipelinePriority: ['', Validators.required],
      ProjectPipelineProbability: ['', Validators.required],
      ProjectPipelineRemark: [''],
      ProjectSaleName: ['']
    });

    this.formProjectSaleQuotation = this.fb.group({
      txtQuotationNo: [null],
      QuotationNoSelect: [''],
      quotationType: ['1', Validators.required],
      txtPrice: [null, Validators.required],
      selectActiveFlag: [null, Validators.required]
    }); 
  }

  async ngOnInit(): Promise<void> {
    this._EmpCode = localStorage.getItem("EmpCode");
    this._RoleCode = localStorage.getItem("EmpRoleCode");
    this.isLoading = true;
    this.cdr.detectChanges(); // Detect changes immediately

    try {
      // load pipeline status
      await this.loadPipelineStatus();

      // load sub state
      await this.LoadFollowupSubState();
      // load priority list
      await this.loadLookup('ISSUEPRIORITY').then((data) => {
        this.PriorityList = data;
      });

      if (this.data) {
        // Extract data directly from the spread object
        this.projectData = this.data;
        this.isViewMode = this.data.isViewMode || false;
        this.isElevated = this.data.isElevated || false;

        // Initialize dropdown lists first
        await this.initializeLists();
        await this.LoadQuotationList();
        await this.LoadProjectSaleQuotaionList();

        // Only patch form values after dropdowns are loaded
        if (this.projectData) {
          let [year, month] = this.projectData.ProjectPipelineClose.split('-').map(part => parseInt(part));

          // Update form with data
          this.form.patchValue({
            ProjectPipelineId: this.projectData.ProjectPipelineId,
            ProjectPipelineProjectSaleId: this.projectData.ProjectPipelineProjectSaleId,
            ProjectPipelineSubStateCode: this.projectData.ProjectPipelineSubStateCode,
            ProjectPipelineSubStateName: this.projectData.ProjectPipelineSubStateName,
            ProjectPipelineStatusLookupCode: this.projectData.ProjectPipelineStatusLookupCode,
            ProjectPipelineStatusLookupValue: this.projectData.ProjectPipelineStatusLookupValue,
            ProjectPipelineCreateBy: this.projectData.ProjectPipelineCreateBy,
            ProjectPipelineCreateDate: this.projectData.ProjectPipelineCreateDate,
            ProjectSaleClosedPeriodMonth: month,
            ProjectSaleClosedPeriodYear: year,
            ProjectPipelineComission: this.projectData.ProjectPipelineComission,
            ProjectPipelinePriority: this.projectData.ProjectPipelinePriority,
            ProjectPipelineProbability: this.projectData.ProjectPipelineProbability,
            ProjectPipelineRemark: this.projectData.ProjectPipelineRemark,
            ProjectSaleName: this.projectData.ProjectSaleName,
            ProjectSaleCode: this.projectData.ProjectSaleCode
          });
        }

        if (this.data.stage && this.data.stage != '0') {
          this.form.patchValue({
            ProjectPipelineStatusLookupCode: this.data.stage
          });

        this.setWinRateByStatus(this.data.stage);
        //this.form.patchValue({ ProjectPipelineProbability: 20 }); // Set %Win Rate ให้ตรงตาม data.stage ที่เป็น 2

          if(this.projectData.ProjectSaleCreateBy != localStorage.getItem("EmpCode") && this.projectData.ProjectSaleAssignTo != localStorage.getItem("EmpCode")) {
            this.isViewMode = true;
          }

          if(this.isElevated){
            this.isViewMode = false;
          }
        }

        console.log(this.projectData)

        // Part validate quotaton no
      this.formProjectSaleQuotation.get('quotationType').valueChanges.subscribe(value => {
        console.log('--- DEBUG: In valueChanges - quotationType changed to:', value);
      this.updateQuotationTypeValidation(value);
    });

    // Call 1 time after formcontrol enable and set follow default
      this.updateQuotationTypeValidation(this.formProjectSaleQuotation.get('quotationType').value);
    // Part validate quotaton no

    // Detect value change of QuotationNoSelect
    this.formProjectSaleQuotation.get('QuotationNoSelect')?.valueChanges.subscribe(value => {
      this.duplicateQuotationError = false;
      if (value) {
        (async () => {  
          const quotationType = this.formProjectSaleQuotation.get('quotationType')?.value;
      const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo')?.value?.trim();
      const selectQuotationNo = value?.trim(); // ← ได้จาก value change โดยตรง

      const quotationNo = quotationType === '1' ? txtQuotationNo : selectQuotationNo;

      const isDuplicate = this.ProjectSaleQuotaionList.some(
        q => q.ProjectSaleQuotationNo === quotationNo
      );

      this.duplicateQuotationError = isDuplicate;

      if (isDuplicate) {
        return; // หยุดไม่ต้องทำงานต่อ
      }




          const selectedQuotation = this.QuotationList.find(q => q.QuotationNo === value);

          //console.log('selectedQuotation.QuotationID', selectedQuotation.QuotationID);
          const quotationProducts = await this.LoadQuotationProductList(selectedQuotation.QuotationID); // ← ต้องรอ
          //console.log('quotationProducts!!', quotationProducts);
            
          const totalNet = quotationProducts.reduce((sum, item) => sum + (item.NetAmountPrice ?? 0), 0);

          this.formProjectSaleQuotation.patchValue({txtPrice: totalNet});
          
          //const quotationType = this.formProjectSaleQuotation.get('quotationType')?.value;
          })();
        }
    });
    // Detect value change of QuotationNoSelect


        // If in view mode, disable all controls
        if (this.isViewMode) {
          this.form.disable();
        }
      }

      this.form.get('ProjectPipelineProbability')?.valueChanges.subscribe(() => {
      this.validateWinRateRange();
    });

    } finally {
      this.isLoading = false;
      this.cdr.detectChanges(); // Final detect changes
    }
  }

  // Call Rest api for load Sub State fix Follow up only
  async LoadFollowupSubState() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['StateCode'] = '1-4';  // Follow Up
      objectjson['FlagActive'] = 'Y';



      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<StateMappingInfo[]>(this.baseurl + "MasterSale/GetMappingStateStatusList",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.ListSubState = data;
        });
    }
  }

  async loadPipelineStatus() {
    await this.loadLookup('PIPELINESTATUS').then((data) => {
      // Filter pipeline options to only show those with LookupCode less than current status
      //const currentStatus = this.InformationForm.get('UpdateForm').get('Pipeline').value;

      // console.log("Current status: ", currentStatus);
      // if (currentStatus) {
      //   this.ListPipeline = data.filter(item => item.LookupCode >= currentStatus);
      // } else {
      //   this.ListPipeline = data;
      // }

      if (!this.isViewMode) this.ListPipeline = data.slice(0, -1); //remove last item (closed)
      if (this.isViewMode) this.ListPipeline = data;
    })
  }

  async loadLookup(lookuptype: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  initializeLists(): Promise<void> {

    // Initialize month names
    this.monthNameslist = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Initialize year list (last 5 years and next 5 years)
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i <= currentYear + 5; i++) {
      this.yearlist.push(i);
    }
    return Promise.resolve();
  }

  displayFieldCss(field: string): string {
    return this.form.get(field)?.invalid && this.form.get(field)?.touched ? 'has-error' : '';
  }

  isFieldValid(field: string): boolean {
    return this.form.get(field)?.invalid && this.form.get(field)?.touched;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    try {
      // Mark all controls as touched to show validation errors
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);
        if (control) {
          control.markAsTouched({ onlySelf: true });
        }
      });

      // Check if form is valid
      if (this.form.invalid) {
        console.log('Form is invalid');
        return;
      }

      // Get form values
      const formData = this.form.value;

      // Validate required fields
      if (!formData.ProjectPipelineSubStateCode) {
        throw new Error('Sub State is required');
      }

      if (!formData.ProjectPipelineStatusLookupCode) {
        throw new Error('Status is required');
      }

      if (!formData.ProjectSaleClosedPeriodMonth || !formData.ProjectSaleClosedPeriodYear) {
        throw new Error('Expected Close Period is required');
      }

      // Validate probability (should be between 0 and 100)
      if (formData.ProjectPipelineProbability && 
          (formData.ProjectPipelineProbability < 0 || formData.ProjectPipelineProbability > 100)) {
        throw new Error('Probability must be between 0 and 100');
      }

      // Validate amounts (should be positive numbers)
      if (formData.ProjectPipelineAmount && formData.ProjectPipelineAmount < 0) {
        throw new Error('Amount cannot be negative');
      }

      if (formData.ProjectPipelineComission && formData.ProjectPipelineComission < 0) {
        throw new Error('Commission cannot be negative');
      }

      // If all validations pass, proceed with saving
      this.InsertPipeline().catch(error => {
        console.error('Error saving pipeline:', error);
        this.dialogRef.close({ success: false, error: error.message });
      });

    } catch (error) {
      console.error('Validation error:', error);
      this.dialogRef.close({ success: false, error: error.message });
    }
  }



  async btnClick_SavePipeline(): Promise<void> {
    try {
      if (!this.validateWinRateRange()) {
        return; // ไม่ submit
      }

      // Validate form
      if (this.form.invalid) {
        this.GlobalService.validateAllFormFields(this.form);
        return;
      }

      // Get auth token
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        throw new Error('No valid token');
      }

      // Prepare HTTP options
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // Prepare data
      const formData = this.form.value;
      const objectjson = {
        ProjectSaleId: this.projectData.ProjectPipelineProjectSaleId,
        ProjectSaleState: '1-4', // Follow up
        ProjectSaleSubState: formData.ProjectPipelineSubStateCode,
        ProjectSaleClosedPeriodMonth: formData.ProjectSaleClosedPeriodMonth,
        ProjectSaleClosedPeriodYear: formData.ProjectSaleClosedPeriodYear,
        ProjectSaleUpdateBy: this.checkUndefinedString(localStorage.getItem("EmpCode")),
        ProjectSaleTeamCode: this.projectData.ProjectSaleTeamCode
      };

      // Show loading
      this.isLoading = true;
      this.cdr.detectChanges();

      // Make API call
      try {
        const response = await this.httpClient.post<ProjectSaleInfo[]>(
          this.baseurl + "ProjectSale/UpdateProjectSale",
          JSON.stringify(objectjson),
          httpOptions
        ).toPromise();

        // If update successful, proceed with pipeline insert
        await this.InsertPipeline();
        
      } catch (error) {
        console.error("Update Project Sale failed:", error);
        throw new Error('Failed to update project sale');
      }

    } catch (error) {
      console.error("Error in SavePipeline:", error);
      this.dialogRef.close({ success: false, error: error.message });
    } finally {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }


  async InsertPipeline(): Promise<void> {
    try {
      if (this.form.invalid) {
        throw new Error('Please fill in all required fields');
      }

      this.isLoading = true;
      this.cdr.detectChanges();

      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        throw new Error('No valid token');
      }

      await this.CheckNewCompanyCode();
      // console.log('projectData.ProjectSaleCode', this.projectData.ProjectSaleCode);
      // console.log('formData.ProjectPipelineStatusLookupCode', this.form.value.ProjectPipelineStatusLookupCode);
      //console.log('NewCompanyCode', this.NewCompanyCode);
      if (this.projectData?.ProjectSaleCode && this.projectData.ProjectSaleCode.includes("LEAD") && this.form.value.ProjectPipelineStatusLookupCode === "4") {
        alert(`ระบบทำการสร้างรหัสลูกค้าใหม่จาก ${this.projectData.ProjectSaleCode} เป็น ${this.NewCompanyCode}`);
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const formData = this.form.value;
      const objectjson = {
        ProjectSaleCode: this.projectData.ProjectSaleCode,
        ProjectSaleID: this.projectData.ProjectPipelineProjectSaleId,
        ProjectPipelineSubStateCode: formData.ProjectPipelineSubStateCode,
        ProjectPipelineStatusLookupCode: formData.ProjectPipelineStatusLookupCode,
        ProjectPipelineClose: new Date(formData.ProjectSaleClosedPeriodYear + '-' + formData.ProjectSaleClosedPeriodMonth.toString().padStart(2, '0')),
        ProjectPipelineAmount: formData.ProjectPipelineAmount || 0,
        ProjectPipelineComission: formData.ProjectPipelineComission || 0,
        ProjectPipelinePriority: this.checkUndefinedString(formData.ProjectPipelinePriority),
        ProjectPipelineProgress: this.projectData.ProjectSaleCloseDealProgress != null ? this.projectData.ProjectSaleCloseDealProgress : '',
        ProjectPipelineProbability: parseInt(formData.ProjectPipelineProbability),
        ProjectPipelineRemark: this.checkUndefinedString(formData.ProjectPipelineRemark),
        ProjectPipelineCreateBy: this.checkUndefinedString(localStorage.getItem("EmpCode")),
        ProjectPipelineFlagDelete: "N"
      };

      const strjson = JSON.stringify(objectjson);

      try {
        const response = await this.httpClient.post<any[]>(this.baseurl + "ProjectPipeline/InsertProjectPipeline", strjson, httpOptions).toPromise();
        console.log("Insert Pipeline successful");
        this.dialogRef.close({ success: true, data: response, reload: true });
      } catch (error) {
        console.error("Insert Pipeline failed:", error);
        throw new Error('Failed to insert pipeline');
      }
    } catch (error) {
      console.error("Error in InsertPipeline:", error);
      this.dialogRef.close({ success: false, error: error.message });
    } finally {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }

  onPipelineStatusChange(event: any) {
    const selectedValue = this.form.controls['ProjectPipelineStatusLookupCode'].value;

    this.setWinRateByStatus(selectedValue);    
  }

  validateWinRateRange() {
  const selectedValue = this.form.controls['ProjectPipelineStatusLookupCode'].value;
  const winRateControl = this.form.controls['ProjectPipelineProbability'];
  const winRate = winRateControl.value;

  let min = 0, max = 0;

  switch (selectedValue) {
    case '1':
      min = 0; max = 19;
      break;
    case '2':
      min = 20; max = 39;
      break;
    case '3':
      min = 40; max = 59;
      break;
    case '4':
      min = 60; max = 79;
      break;
    case '5':
      min = 80; max = 99;
      break;
    default:
      winRateControl.setErrors({ invalidPipelineStatus: true });
      return false;
  }

  if (winRate < min || winRate > max) {
    winRateControl.setErrors({ outOfRange: { min, max } });
    return false;
  } else {
    // ถ้าไม่มี error อื่นอยู่ ให้ล้าง error
    if (winRateControl.hasError('outOfRange') || winRateControl.hasError('invalidPipelineStatus')) {
      winRateControl.setErrors(null);
    }
    return true;
  }
}

private setWinRateByStatus(statusCode: string | null): void {

  console.log('statuscode: ', statusCode);
  let winRate = null;

  switch (statusCode) {
    case '1':
      winRate = 0;
      break;
    case '2':
      winRate = 20;
      break;
    case '3':
      winRate = 40;
      break;
    case '4':
      winRate = 60;
      break;
    case '5':
      winRate = 80;
      break;
    default:
      winRate = null;
  }

  this.form.get('ProjectPipelineProbability')?.setValue(winRate, { emitEvent: false });
  this.validateWinRateRange(); // หากต้องการ validate ทันที
}

async LoadProjectSaleQuotaionList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      //console.log('this.projectData.ProjectPipelineProjectSaleId', this.projectData.ProjectPipelineProjectSaleId);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      //const objectjson = {
        //rowFetch: environment.PageSize,
        //rowOFFSet: ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * environment.PageSize
      //};

      var objectjson = {};

        objectjson['ProjectSaleID'] = this.projectData.ProjectPipelineProjectSaleId;

      const response = await this.httpClient.post<any>(
        this.baseurl + "ProjectSaleQuotation/GetProjectSaleQuotation",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.ProjectSaleQuotaionList = response;
      //this.totalItems = this.CompanyList.length;

      // if (this.CompanyList.length <= 0) {
      //   this.currentPageNumber = 0;
      // } else {
      //   if (this.currentPageNumber == 0) this.currentPageNumber = 1;
      //   this.totalItems = Number(this.CompanyList[0].itemTotal);
      // }

      // this.totalPages = Math.ceil(this.totalItems / environment.PageSize);

      //console.log('PageSize:', environment.PageSize);
      //console.log('Total Items:', this.totalItems);
      //console.log('Total Pages:', this.totalPages);
      
    } catch (error) {
      console.error('Error loading company group:', error);
      //alert('An error occurred while loading company group data. Please try again.');
    } finally {
    }
  }

btnClick_onCreateProjectSaleQuotation() {
  this.isOnUpdateProjectSaleQuotation = false;
  this.formProjectSaleQuotation.reset();
  setTimeout(() => {
      this.onPriceBlur();
    }, 0)

    this.formProjectSaleQuotation.patchValue({
      quotationType: '1',
      selectActiveFlag: 'Y',
      QuotationNoSelect: ''
    });

  $('#ModalQuotation').modal('show');
}

isFieldQuotationValid(field: string): boolean {
    return this.formProjectSaleQuotation.get(field)?.invalid && this.formProjectSaleQuotation.get(field)?.touched;
  }

validateAllFormFields(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach(field => {
    const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

async btnClick_submitInsertProjectSaleQuotation() {
    const quotationType = this.formProjectSaleQuotation.get('quotationType')?.value;
    const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo')?.value?.trim();
    const selectQuotationNo = this.formProjectSaleQuotation.get('QuotationNoSelect')?.value?.trim();

    const quotationNo = quotationType === '1' ? txtQuotationNo : selectQuotationNo;

    const isDuplicate = this.ProjectSaleQuotaionList.some(
  q => q.ProjectSaleQuotationNo === quotationNo
);

if (isDuplicate) {
  this.duplicateQuotationError = true; // ให้ flag เพื่อ ngIf แสดง error
  return;
} else {
  this.duplicateQuotationError = false;
}

//console.log('txtQuotationNo', this.formProjectSaleQuotation.value.txtQuotationNo)
this.formProjectSaleQuotation.updateValueAndValidity();
    if (this.formProjectSaleQuotation.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form submitted');
        //this.OnCreating('y');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        const quotationType = this.formProjectSaleQuotation.get('quotationType')?.value;
        const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo')?.value?.trim();
        const selectQuotationNo = this.formProjectSaleQuotation.get('QuotationNoSelect')?.value?.trim();
        const rawFormValue = this.formProjectSaleQuotation.getRawValue();

        var objectjson = {};
        objectjson['ProjectSaleID'] = this.projectData.ProjectPipelineProjectSaleId;
        objectjson['ProjectSaleCode'] = this.projectData.ProjectSaleCode;
        objectjson['ProjectSaleQuotationType'] = quotationType;
        //objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(this.formProjectSaleQuotation.value.txtQuotationNo);
        objectjson['ProjectSaleQuotationPrice'] = this.formProjectSaleQuotation.value.txtPrice; // number
        objectjson['ProjectSaleQuotationPrice'] = rawFormValue.txtPrice;
        objectjson['ProjectSaleQuotationActiveFlag'] = this.checkUndefinedString(this.formProjectSaleQuotation.value.selectActiveFlag);
        objectjson['ProjectSaleQuotationCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        if (quotationType === '1') {
        objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(txtQuotationNo);
      } else if (quotationType === '2') {
        objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(selectQuotationNo);
      }


        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleQuotationInfo[]>(this.baseurl + "ProjectSaleQuotation/InsertProjectSaleQuotation", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            //this.OnCreating('n');            
          },
            async () => {
              console.log("Insert = " + this.isSubmitted)

              if (!!this.projectsaleQuotationFilesToUpload && this.projectsaleQuotationFilesToUpload.length > 0) {
        console.log('projectsaleQuotationFilesToUpload!!', this.projectsaleQuotationFilesToUpload);
              var isUploadSuccess = await this.UploadProjectSaleQuotationAttachedFilesToServer(this.projectsaleQuotationFilesToUpload);
              if (isUploadSuccess) {
                for (const val of this.projectsaleQuotationFilesToUpload) {
                  await this.InsertProjectSaleQuotationAttachedFile(val.name, this.projectsaleQuotationPathFile + "\\" + val.name, this.isSubmitted)
                }
              }

              //$('#ModalProjectSaleBudgetCreateComplete').modal();
              this.IsClearProjectSaleQuotationAttachedmentList = "true";
              this.projectsaleQuotationFilesToUpload = [];
              //this.LoadProjectSaleBudgetAttachedFile(this.isSubmitted);
            }

              $('#ModalQuotation').modal('hide');
              $('#ModalCreateQuotationComplete').modal();
              this.LoadProjectSaleQuotaionList();
              await this.UpdateProjectSaleActualPriceByQuotation();

            }
          )

      }

    } else {
      this.validateAllFormFields(this.formProjectSaleQuotation);
    }
  }

  async btnClick_onUpdateProjectSaleQuotation(id) {
    $('#ModalQuotation').modal('hide');
    this.isOnUpdateProjectSaleQuotation = true;
    const index = this.ProjectSaleQuotaionList.findIndex(x => x.ProjectSaleQuotationID === id);

    console.log('id!!!', id)
    console.log('index!!!', index)

    this.hidProjectSaleQuotaionID = id; // index for update

  if (index === -1) return;

  const item = this.ProjectSaleQuotaionList[index]; 

  const quotationType = String(item.ProjectSaleQuotationType ?? '1');

  this.formProjectSaleQuotation.patchValue({
    txtQuotationNo: quotationType === '1' ? item.ProjectSaleQuotationNo ?? '' : '',
    QuotationNoSelect: quotationType === '2' ? item.ProjectSaleQuotationNo ?? '' : '',
    //txtPrice: item.ProjectSaleQuotationPrice ?? null,
    selectActiveFlag: item.ProjectSaleQuotationActiveFlag ?? null,
    quotationType: String(item.ProjectSaleQuotationType ?? '1')
  });

  if (quotationType === '2') {
    const quotationNoSelect = this.formProjectSaleQuotation.get('QuotationNoSelect');
    quotationNoSelect.markAsPristine();
    quotationNoSelect.markAsUntouched();
    quotationNoSelect.updateValueAndValidity();
    this.duplicateQuotationError = false;
  } else {
    const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo');
    txtQuotationNo.markAsPristine();
    txtQuotationNo.markAsUntouched();
    txtQuotationNo.updateValueAndValidity();
    this.duplicateQuotationError = false;
  }



  if (quotationType === '1') {
  this.formProjectSaleQuotation.get('txtPrice')?.setValue(item.ProjectSaleQuotationPrice ?? '');
  this.formProjectSaleQuotation.get('txtPrice')?.enable();
} else {
  // ในกรณี '2' ให้ disable และรอ valueChanges ทำงานเอง
  this.formProjectSaleQuotation.get('txtPrice')?.disable();
}

  setTimeout(() => {
      this.onPriceBlur();
    }, 0)

    await this.LoadProjectSaleQuotationAttachedment(id);

  $('#ModalQuotation').modal('show');
  }

  async btnClick_submitUpdateProjectSaleQuotation(id) {
      this.formProjectSaleQuotation.updateValueAndValidity();

      const selectedType = this.formProjectSaleQuotation.get('quotationType').value;
      const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo')?.value?.trim();
      const selectQuotationNo = this.formProjectSaleQuotation.get('QuotationNoSelect')?.value?.trim();
      const quotationNo = selectedType === '1' ? txtQuotationNo : selectQuotationNo;

      const found = this.ProjectSaleQuotaionList.find(
        q => q.ProjectSaleQuotationNo === quotationNo
      );

      if (found && found.ProjectSaleQuotationID !== this.hidProjectSaleQuotaionID) {
        this.duplicateQuotationError = true;
        return;
      } else {
        this.duplicateQuotationError = false;
      }

      const txtPriceControl = this.formProjectSaleQuotation.get('txtPrice');
      const price = txtPriceControl.disabled ? txtPriceControl.value : this.formProjectSaleQuotation.value.txtPrice;

      if (this.formProjectSaleQuotation.valid) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          //this.OnUpdating('y');
  
          id = this.hidProjectSaleQuotaionID
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
  
            })
          };
  
          const quotationType = this.formProjectSaleQuotation.get('quotationType')?.value;

          var objectjson = {};
        objectjson['ProjectSaleQuotationID'] = this.hidProjectSaleQuotaionID;
        objectjson['ProjectSaleQuotationType'] = quotationType;
        //objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(this.formProjectSaleQuotation.value.txtQuotationNo);
        objectjson['ProjectSaleQuotationPrice'] = price; // number
        objectjson['ProjectSaleQuotationActiveFlag'] = this.checkUndefinedString(this.formProjectSaleQuotation.value.selectActiveFlag);
        objectjson['ProjectSaleQuotationUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

          if (quotationType === '1') {
          objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(txtQuotationNo);
        } else if (quotationType === '2') {
          objectjson['ProjectSaleQuotationNo'] = this.checkUndefinedString(selectQuotationNo);
        }
  
          let strjson = JSON.stringify(objectjson);
  
          this.isSubmitted = this.httpClient.post<ProjectSaleQuotationInfo[]>(this.baseurl + "ProjectSaleQuotation/UpdateProjectSaleQuotation", strjson, httpOptions)
  
            .subscribe(result => this.isSubmitted = result, failCb => {
              console.log("Update fail");
              //this.OnUpdating('n');
            },
              async () => {
                console.log("Update = " + this.isSubmitted);
                //this.OnUpdating('n');
                $('#ModalQuotation').modal('hide');
                $('#ModalCreateQuotationComplete').modal();

                                if (!!this.projectsaleQuotationFilesToUpload && this.projectsaleQuotationFilesToUpload.length > 0) {
                  //console.log('projectsaleQuotationFilesToUpload!!', this.projectsaleQuotationFilesToUpload);
                  var isUploadSuccess = await this.UploadProjectSaleQuotationAttachedFilesToServer(this.projectsaleQuotationFilesToUpload);
                  if (isUploadSuccess) {
                    for (const val of this.projectsaleQuotationFilesToUpload) {
                      await this.InsertProjectSaleQuotationAttachedFile(val.name, this.projectsaleQuotationPathFile + "\\" + val.name, this.hidProjectSaleQuotaionID)
                  }
                  this.IsClearProjectSaleQuotationAttachedmentList = "true";
                  this.projectsaleQuotationFilesToUpload = [];
                }

              //$('#ModalProjectSaleBudgetCreateComplete').modal();
              
              //this.LoadProjectSaleBudgetAttachedFile(this.isSubmitted);
            }

                this.LoadProjectSaleQuotaionList();
                this.UpdateProjectSaleActualPriceByQuotation();
              }
            )
        }
      } else {
        this.validateAllFormFields(this.form);
      }
  }

  chkallProjectSaleQuotationclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxProjectSaleQuotaion"]').prop('checked', check);

  }

  
  async btnClick_onDeleteProjectSaleQuotationList() {
  if (confirm("Are you sure to delete this Quotation?")) {
  
        var checkkedcompanygroup = $('[name="checkboxProjectSaleQuotaion"]:checked');
        let num = checkkedcompanygroup.length;
        let listCompanyGroupModel = [];
        
  
        for (var i = 0; i < num; i++) {
          var CompanyGroupcurrent = <HTMLInputElement>checkkedcompanygroup[i];
          let companygroupInfo = new ProjectSaleQuotationInfo;
          companygroupInfo.ProjectSaleQuotationID = parseInt(CompanyGroupcurrent.value);
  
            var currentCompanyGroup = this.ProjectSaleQuotaionList.filter(x => { return x.ProjectSaleQuotationID == companygroupInfo.ProjectSaleQuotationID });
            var isOwner = (currentCompanyGroup[0].ProjectSaleQuotationCreateBy == this._EmpCode);
  
            console.log(" Delete id = " + companygroupInfo.ProjectSaleQuotationID + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
            if (isOwner || (this._RoleCode != "")) {
              listCompanyGroupModel.push(companygroupInfo);
            } else
            {
              //this.titlemodal = ""
              //this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
              this.detailmodal = "You don't have permission to delete this company. Please contact" + currentCompanyGroup[0].ProjectSaleQuotationCreateBy;
              $('#ModalError .modal-header').text("Information");
              $('#ModalError .modal-header').addClass('bg-blue');
              $('#ModalError').modal();
  
              listCompanyGroupModel = [];
              break; //break loop
            }
        }
  
        if (listCompanyGroupModel.length > 0) {
          this.deleteListProjectSaleQuotation(listCompanyGroupModel)
        }
  
      }
    }

  async deleteListProjectSaleQuotation(listProjectSaleQuotation: any[]) {
  console.log('Prepare Delete333', listProjectSaleQuotation);

  const auth_token = await this.TokenService.RefreshToken();
  if (!auth_token) { return; }

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${auth_token}`
    })
  };

  const strjsonCusInfo = JSON.stringify(listProjectSaleQuotation);

  this.httpClient.post<ProjectSaleQuotationInfo[]>(
      this.baseurl + 'ProjectSaleQuotation/DeleteListProjectSaleQuotation',
      strjsonCusInfo,
      httpOptions
    )
    .toPromise()
    .then(async () => {               // <<-- ใส่ async เพื่อใช้ await ด้านใน
      console.log('delete quotation list successfully');
      $('#ModalDeleteComplete').modal('show');

      // ถ้าเมธอดนี้ไม่คืน Promise เอา await ออกได้ตามสะดวก
      await this.UpdateProjectSaleActualPriceByQuotation();
      await this.LoadProjectSaleQuotaionList();

      
    })
    .catch(err => console.log(err));
}


  async UpdateProjectSaleActualPriceByQuotation(): Promise<void> {
  // ✅ ถ้าไม่ใช้ฟอร์มในการเช็ก ให้ลบ if นี้ออก
  if (!this.formProjectSaleQuotation.valid) {
    this.validateAllFormFields(this.formProjectSaleQuotation);
    return;
  }

  const auth_token = await this.TokenService.RefreshToken();
  if (!auth_token) return;

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${auth_token}`
    })
  };

  const objectjson = {
    ProjectSaleID: this.projectData.ProjectPipelineProjectSaleId,
    ProjectSaleQuotationUpdateBy: this.checkUndefinedString(localStorage.getItem("EmpCode"))
  };

  const strjson = JSON.stringify(objectjson);

  try {
    const result = await this.httpClient
      .post<ProjectSaleQuotationInfo[]>(
        this.baseurl + 'ProjectSaleQuotation/UpdateProjectSaleActualPriceByQuotation',
        strjson,
        httpOptions
      )
      .toPromise();

    this.isSubmitted = result;
    console.log("Update = ", result);
  } catch (err) {
    console.log("Update fail", err);
  }
}

formatPrice(value: number | string | null | undefined): string {
  if (value == null || value === '') return '';
  
  // remove comma before set number format
  const cleanedValue = String(value).replace(/,/g, '');
  const num = parseFloat(cleanedValue);
  
  if (isNaN(num)) {
    return '';
  }
  
  // use toLocaleString set minimum/maximumFractionDigits is 2
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

onPriceFocus() {
  const inputElement = document.getElementById('txtPrice') as HTMLInputElement;
  if (inputElement) {
    // remove formatting focus
    const currentValue = inputElement.value;
    if (currentValue) {
      const cleanValue = currentValue.replace(/,/g, '');
      inputElement.value = cleanValue;
    }
  }
}

onPriceInput(event: Event) {
  const input = event.target as HTMLInputElement;
  let rawValue = input.value;
  
  // set cleanvalue: remove not contains comma & decimal
  let cleanValue = rawValue.replace(/[^0-9.]/g, '');
  
  // validate keep only first . position
  const parts = cleanValue.split('.');
  if (parts.length > 2) {
    cleanValue = parts[0] + '.' + parts.slice(1).join('');
  }
  
  // limit 2 decimal format
  if (parts.length === 2 && parts[1].length > 2) {
    cleanValue = parts[0] + '.' + parts[1].substring(0, 2);
  }
  
  // update input value match clean value
  input.value = cleanValue;
  
  // transform real number format FormControl
  const num = parseFloat(cleanValue);
  
  // update FormControl to Number
  this.formProjectSaleQuotation.get('txtPrice')?.setValue(
    isNaN(num) ? null : num, 
    { emitEvent: false }
  );
}

onPriceBlur() {
  const control = this.formProjectSaleQuotation.get('txtPrice');
  const numericValue = control?.value;
  
  const inputElement = document.getElementById('txtPrice') as HTMLInputElement;
  
  if (inputElement) {
    if (numericValue != null && numericValue !== '') {
      const formatted = this.formatPrice(numericValue);
      inputElement.value = formatted;
    } else {
      inputElement.value = '';
    }
  }
}

clearForm() {
  this.formProjectSaleQuotation.reset();
  const inputElement = document.getElementById('txtPrice') as HTMLInputElement;
  if (inputElement) {
    inputElement.value = '';
  }
}

updateQuotationTypeValidation(type: string): void {
  const txtQuotationNo = this.formProjectSaleQuotation.get('txtQuotationNo');
  const quotationNoSelect = this.formProjectSaleQuotation.get('QuotationNoSelect');
  const txtPrice = this.formProjectSaleQuotation.get('txtPrice');

  if (type === '1') {
    // Manual Quotation: use only txtQuotationNo 
    txtQuotationNo.setValidators([Validators.required]);
    quotationNoSelect.clearValidators();
    quotationNoSelect.setValue('');
    txtPrice.enable();
    txtPrice.setValue('');
  } else if (type === '2') {
    // Quotation List: use only QuotationNoSelect
    quotationNoSelect.setValidators([Validators.required]);
    txtQuotationNo.clearValidators();
    txtQuotationNo.setValue('');
    txtPrice.disable();
  }

  txtQuotationNo.updateValueAndValidity();
  quotationNoSelect.updateValueAndValidity();
  txtPrice.updateValueAndValidity();
}

async LoadQuotationList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      //console.log('this.projectData.ProjectPipelineProjectSaleId', this.projectData.ProjectPipelineProjectSaleId);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      //const objectjson = {
        //rowFetch: environment.PageSize,
        //rowOFFSet: ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * environment.PageSize
      //};

      var objectjson = {};

        objectjson['QuotationProjectSaleID'] = this.projectData.ProjectPipelineProjectSaleId;

      const response = await this.httpClient.post<any>(
        this.baseurl + "Quotation/GetQuotation",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.QuotationList = response;
      //this.totalItems = this.CompanyList.length;

      // if (this.CompanyList.length <= 0) {
      //   this.currentPageNumber = 0;
      // } else {
      //   if (this.currentPageNumber == 0) this.currentPageNumber = 1;
      //   this.totalItems = Number(this.CompanyList[0].itemTotal);
      // }

      // this.totalPages = Math.ceil(this.totalItems / environment.PageSize);

      //console.log('PageSize:', environment.PageSize);
      //console.log('Total Items:', this.totalItems);
      //console.log('Total Pages:', this.totalPages);
      
    } catch (error) {
      console.error('Error loading company group:', error);
      //alert('An error occurred while loading company group data. Please try again.');
    } finally {
    }
  }

  async LoadQuotationProductList(id: number): Promise<any[]> {
   try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

        objectjson['QuotationID'] = id;

      const response = await this.httpClient.post<any>(this.baseurl + "Quotation/GetQuotationProduct", JSON.stringify(objectjson),
        httpOptions).toPromise();

      this.QuotationProductList = response;
      return this.QuotationProductList;
    } catch (error) {
      console.error('Error loading company group:', error);
      //alert('An error occurred while loading company group data. Please try again.');
    } finally {
    }
}

DragFilesProjectQuotationAttachedmentFinished(returnObj) {
if (!!returnObj.Message) {
      alert(returnObj.Message)
    } else {
      this.projectsaleQuotationFilesToUpload = returnObj.Files;
      this.projectsaleQuotationPathFile = returnObj.PathFile;
    }
  }

  async UploadProjectSaleQuotationAttachedFilesToServer(files) {

    if (!files || files.length === 0) {
      alert("Please browse file at least one.")
      return false;
    }
    let filesToUpload: File[] = files;

    await Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.projectsaleQuotationPathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
            }

          } else if (event.type === HttpEventType.Response) {
          }
        });



    });

    return true;
  }

  async InsertProjectSaleQuotationAttachedFile(Filename, pathfile, projectsalequotationid) {
    console.log('call insert attachment', Filename, pathfile, projectsalequotationid);
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      console.log('call insert attachment true', Filename, pathfile, projectsalequotationid);

      var objectjson = {};
      objectjson['ProjectSaleQuotationID'] = projectsalequotationid;
      objectjson['ProjectSaleQuotationAttachmentFileName'] = Filename;
      objectjson['ProjectSaleQuotationAttachmentPathFile'] = pathfile;
      objectjson['ProjectSaleQuotationAttachmentFlagDelete'] = "N";
      objectjson['ProjectSaleQuotationAttachmentCreateBy'] = localStorage.getItem("EmpCode");




      let strjson = JSON.stringify(objectjson);

      console.log('strjson attach quotation', strjson);

      this.isProjectSaleQuotationAttachedmentSubmitted = this.httpClient.post<ProjectSaleQuotationAttachmentInfo[]>(this.baseurl + "ProjectSaleQuotation/InsertProjectSaleQuotationAttachedFile", strjson, httpOptions)

        .subscribe(result => this.isProjectSaleQuotationAttachedmentSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isProjectSaleQuotationAttachedmentSubmitted)
          }
        )
    }
  }

  async LoadProjectSaleQuotationAttachedment(projectsalequotationid) {
    var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        await this.LoadProjectSaleQuotationAttachedmentList(projectsalequotationid, auth_token)
          .then(data => {
            this.ProjectSaleQuotationAttachedmentList = data;
          })
        .catch(error => {
      console.error('There was an error!', error);
      });
    }
  }

  async LoadProjectSaleQuotationAttachedmentList(projectsalequotationid, auth_token): Promise<ProjectSaleQuotationAttachmentInfo[]> {

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${auth_token}`
    })
  };

  var objectjson = {};

  objectjson['ProjectSaleQuotationID'] = projectsalequotationid;

  let strjson = JSON.stringify(objectjson);

  return this.httpClient
    .post<ProjectSaleQuotationAttachmentInfo[]>(this.baseurl + "ProjectSaleQuotation/GetProjectSaleQuotationAttachment",
      strjson, httpOptions)
    .toPromise(); // Convert the Observable to a Promise
  }

  OnDeleteProjectSaleQuotationAttachedmentClick(elem) {
    let dataInfo = $(elem).parent().data();
    if (Object.keys(dataInfo).length > 0) {
      //Confirm to delete
      this.modalDocInfo = dataInfo;
      this.modalDocName = dataInfo.documentname;
      $('#ModalConfirmDeleteProjectSaleQuotationAttachedFile').modal();
    }
  }

  async DeleteProjectSaleQuotationAttachedFile() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleQuotationAttachmentID'] = this.modalDocInfo.documentid;

      let strjson = JSON.stringify(objectjson);
      this.httpClient
        .post<boolean>(this.baseurl + "ProjectSaleQuotation/DeleteProjectSaleQuotationAttachedFile",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            if (data) {
              this.titlemodal = "Success";
              this.detailmodal = "The attached file has been deleted."
              this.LoadProjectSaleQuotaionList();
              this.LoadProjectSaleQuotationAttachedment(this.modalDocInfo.projectsalequotationid);
            } else {
              this.titlemodal = "Sorry";
              this.detailmodal = "Delete fail."
            }
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
    }
  }

  async btn_LoadProjectSaleQuotationAttachedFile(id: any) {
  try {
    const auth_token = await this.TokenService.RefreshToken();
    if (auth_token) {
      const data = await this.LoadProjectSaleQuotationAttachedmentList(id, auth_token);
      this.ProjectSaleQuotationAttachedmentList = data;
      $('#modalProjectSaleQuotationAttachedFile').modal('show');
    }
  } catch (error) {
    console.error('There was an error!', error);
    // สามารถเพิ่มโค้ดแจ้งเตือนผู้ใช้ในส่วนนี้ได้
  }
}

  async CheckNewCompanyCode(){
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

        objectjson['ProjectPipelineProjectSaleId'] = this.projectData.ProjectPipelineProjectSaleId;

      const response = await this.httpClient.post<any>(this.baseurl + "ProjectPipeline/GenerateCompanyCode", objectjson, httpOptions).toPromise();

      this.NewCompanyCode = response?.ProjectPipelineCompanyCode;
      
    } catch (error) {
      console.error('Error loading company group:', error);
      //alert('An error occurred while loading company group data. Please try again.');
    } finally {
    }
  }


}
